module.exports = __webpack_public_path__ + "static/media/card-MAU.69f2867b.svg";